import React from 'react';
import type Stylus from '../stylus/Stylus';
import styles from '../styles.module.css';

export const stylusComponent = (stylus: Stylus) => {
  const menuComponent = stylus.menuComponent();
  if (menuComponent) {
    return menuComponent;
  }

  return stylus.renderIcon();
};

export const labeledMenuComponent = (
  renderedIcon: React.ReactNode,
  description: string
) => (
  <div className={styles.labeledToolButtonContent}>
    <span className={styles.labeledToolButtonIcon}>{renderedIcon}</span>
    <span className={styles.labeledToolButtonLabel}>{description}</span>
  </div>
);
